import React, { useRef, useState, useEffect, useCallback } from 'react';
import Navbar from '../../layout/Navbar/Navbar';
import Sidebar from '../../layout/Sidebar/SideBar';
import { Form, Modal } from 'react-bootstrap';
import { ModalApontamento } from './ModalApontamento';
import { Print, CropFree, EditNote, Laptop, FindReplace, AddAPhoto, ArrowCircleLeft, Note } from '@mui/icons-material';
import JsBarcode from 'jsbarcode';
import { XMLSerializer } from 'xmldom';
import blogFetch from '../../axios/config';
import toast from 'react-hot-toast';
import { TabelaApontametosACV } from './TabelaApontametosACV';
import { ModalApontamentoACV } from './ModalApontamentoACV';
import axios from 'axios';
import { Apontamento, DTO, FornoValidationItem, LossCause, LossOrigin, Origin } from './Types';
import { RESERVED } from '../molds/CardMolds';
import Webcam from "react-webcam";
import { TabelInspecos } from './TabelaInspecoes';
import { TabelaResumoOrdens } from './TabelaResumoOrdens';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import ModalApontamentoEmbolsado from './ModalApontamentoEmbolsado';
import ModalApontamentoPmont from './ModalApontamentoPmont';
import ModalApontamentoEmpolvado from './ModalApontamentoEmpolvado';
import { ModalQRSerigrafia } from './ModalQRSerigrafia';
import { ModalApontamentoSerigrafia } from './ModalApontamentoSerigrafia';
import ModalApontamentoInspFinal from './ModalApontamentoInspFinal';

export const Apontamento_SAP = () => {
    //#region States

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const gsaOrder = searchParams.get('gsaOrder');
    const gsaSector = searchParams.get('gsaSector');

    const [modalImpressao, setModalImpressao] = useState(false);
    const [modalVerificador, setModalVerificador] = useState(false);
    const [modalACV, setModalACV] = useState(false);
    const [modalApontACVModal, setModalApontACVModal] = useState(false);
    const [centroTrabalhoSelect, setCentroTrabalhoSelect] = useState(gsaSector ?? '');
    const [ordem, setOrdem] = useState('');
    const [loteVerificar, setLoteVerificar] = useState('');
    const [loteVerificador, setLoteVerificador] = useState('');
    const [ciclo, setCiclo] = useState('');
    const [tipoApontamentoACV, setTipoApontamentoACV] = useState('');
    const svgRef = useRef<SVGSVGElement | null>(null);
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const [modal, setModal] = useState(false);
    const [lossModal, setLossModal] = useState(!!(gsaOrder && gsaSector));
    const [confirmSubmitModal, setConfirmSubmitModal] = useState(false);
    const [sameDefectModal, setSameDefectModal] = useState(false);
    const [photoModal, setPhotoModal] = useState(false);
    const [order, setOrder] = useState<string>(gsaOrder ?? "")
    const [appointmentType, setAppointmentType] = useState<string>("")
    const abortControllerRef = useRef<AbortController | null>(null);
    const [orderFound, setOrderFound] = useState<boolean>(false);
    const [dto, setDTO] = useState<DTO>();
    const [origins, setOrigins] = useState<Origin[]>([]);
    const [groupDefects, setGroupDefects] = useState<Origin[]>([]);
    const [defects, setDefects] = useState<Origin[]>([]);
    const [causes, setCauses] = useState<Origin[]>([]);
    const [origin, setOrigin] = useState<LossOrigin>();
    const [defectGroup, setDefectGroup] = useState<string>();
    const [defect, setDefect] = useState<string>();
    const [equipment, setEquipment] = useState<string>();
    const [modalEmbolsado, setModalEmbolsado] = useState(false);
    const [modalPmont, setModalPmont] = useState(false);
    const [modalEmpolvado, setModalEmpolvado] = useState(false);
    const [modalQRSerigrafia, setModalQRSerigrafia] = useState(false);
    const [modalApontarSerigrafia, setModalApontarSerigrafia] = useState(false);
    const [modalInspFinal, setModalInspFinal] = useState(false);

    const [apontamentos, setApontamentos] = useState<Apontamento[]>([]);


    const [ordemSelecionada, setOrdemSelecionada] = useState<string>("");

    useEffect(() => {
        const ordem = localStorage.getItem("ordemApontamento");

        if (ordem) {
            setCentroTrabalhoSelect("14MONTAG");
            setOrdemSelecionada(ordem);
            localStorage.removeItem("ordemApontamento");
        }
    }, []);

    const location = useLocation();
    const [cause, setCause] = useState<LossCause>();
    const [observations, setObservations] = useState<string>();
    const [destiny, setDestiny] = useState<string>("");
    const [enableAppontmentSubmit, setEnableAppontmentSubmit] = useState<boolean>(false);
    const [photo, setPhoto] = useState<File>();
    const [imageUrl, setImageUrl] = useState<string>("");
    const webcamRef = useRef<Webcam>(null);
    const videoConstraints = {
        width: 800,
        height: 600,
        facingMode: "environment"
    };
    const [atualizarListaACV, setAtualizarListaACV] = useState(0);
    const [fornoValidationModal, setFornoValidationModal] = useState(false);
    const [fornoValidationData, setFornoValidationData] = useState<FornoValidationItem[]>([]);

    const CentroTrabalho = [
        '01CORTE', '01HIDCOR', '03SERIG', '05EMPOLV', '06CURVAD', '09IOX_E',
        '09IOX_S', '12P_MONT', '13PRE_IB', '14MONTAG', '15EMBOL',
        '16ACV', '18INSFIN', '57ENGENH', '57LABORA'
    ];

    // const Destinos = ["12P_MONT-PREMONT", "13PRE_IB-PREIB33"];

    const Destinos = [
        "01CORTE-01VEXTU", "01CORTE-02VP01U", "01CORTE-03VP02U", "01CORTE-32VPMOU", "01CORTE-33VPR01",
        "01CORTE-36VTPAU", "03SERIG-03VP02U", "05EMPOLV-EMPOLVA", "06CURVAD-ENTH", "06CURVAD-SALH", "09IOX_E-ENTIOX",
        "09IOX_E-INSLITE", "09IOX_S-SALIOX2", "12P_MONT-PREMONT", "13PRE_IB-PREIB33", "14MONTAG-MONTAGE", "15EMBOL-EMBOLSA", "16ACV-EACV",
        "16ACV-SACV", "18INSFIN-INSPFIN"];

    const CentroTrabalhoReprocesso = [
        "01CORTE",
        "01HIDCOR",
        "09IOX_E",
        "09IOX_S",
        "06CURVAD",
        "12P_MONT",
        "14MONTAG",
        "15EMBOL",
        "18INSFIN",
        "57LABORA"
    ];

    const CentroTrabalhoRefugo = [
        "09IOX_E",
        "09IOX_S",
        "06CURVAD",
        "12P_MONT",
        "13PRE_IB",
        "14MONTAG",
        "15EMBOL",
        "18INSFIN",
        "57LABORA"
    ];

    const CentroTrabalhoRetrabalho = [
        "18INSFIN"
    ];
    const CentroTrabalhoSemApontamentoPerda = [
        "03SERIG", "05EMPOLV", "16ACV"
    ]


    //#endregion

    //#region UseEffects

    const handleGoBack = () => {
        navigate(-1); // Volta para a página anterior
    };

    useEffect(() => {
        const fetchOrder = async () => {
            if (order !== "") {
                await getOrder();
            }
        };
        fetchOrder();
    }, [order])

    useEffect(() => {
        if (centroTrabalhoSelect) {
            GetOriginBySector(centroTrabalhoSelect);
            GetAppointmentsBySector(centroTrabalhoSelect);
        } else {
            // Limpar dados quando nenhum centro é selecionado
            setApontamentos([]);
            ClearData();
        }
    }, [centroTrabalhoSelect])

    useEffect(() => {
        if (origin) {
            GetGroupDefectByOrigin(origin.Origem_Cod);
        }
        setDefectGroup(undefined);
        setDefect(undefined);
        setCause(undefined);

    }, [origin])

    useEffect(() => {
        if (defectGroup && origin) {
            GetDefectByGroupDefect(origin.Origem_Cod, defectGroup);
        }
        setDefect(undefined);
        setCause(undefined);
    }, [defectGroup])

    useEffect(() => {
        if (defect && origin && defectGroup) {
            GetCausesByDefect(origin.Origem_Cod, defectGroup, defect);
        }
        setCause(undefined);
    }, [defect])

    useEffect(() => {
        if (dto) {

            // if (!dto.Premont) {
            setDestiny("12P_MONT-PREMONT")
            // }
            // else {
            //     setDestiny("13PRE_IB-PREIB33")
            // }

        }
    }, [dto])

    useEffect(() => {
        if (cause == undefined || dto?.inGSA == false)
            setEnableAppontmentSubmit(false);
        else
            setEnableAppontmentSubmit(true);

    }, [cause, dto?.inGSA])

    //#endregion

    //#region Utils
    const resetApontamentoACV = () => {
        setCiclo('');
        setTipoApontamentoACV('');
    };

    const resetLotes = () => {
        setLoteVerificar('');
        setLoteVerificador('');
    };

    const resetOrdem = () => {
        setOrdem('');
    };
    //#endregion

    //#region Handlers
    const handleImpressaoCloseModal = () => {
        resetOrdem();
        setModalImpressao(false);
    };

    const handleModalCloseVerificador = () => {
        resetLotes();
        setModalVerificador(false);
    };

    const handleACVCloseModal = () => {
        setModalACV(false);
    };




    const handleCloseACVApontModal = () => {
        resetApontamentoACV();
        setModalApontACVModal(false);
    };

    //#region Handlers
    const handleCloseModal = () => setModal(false);
    const handleShowModal = () => setModal(true);
    const handleImpressaoShowModal = () => setModalImpressao(true);
    const handleModalVerificador = () => setModalVerificador(true);
    const handleACVShowModal = () => setModalACV(true);
    const handleShowACVApontModal = () => setModalApontACVModal(true)

    //#endregion

    //#region Funções

    const GetOriginBySector = async (centroTrabalho: string) => {
        try {
            const { data } = await blogFetch.get(`/CatalogoDefeitos/Origin/${centroTrabalho}`);
            setOrigins(data);
            return data
        } catch (error) {
            console.error(error);
        };
    };


    const GetAppointmentsBySector = async (centroTrabalho: string) => {
        try {
            const { data } = await blogFetch.get(`ISAGA_ApontamentoSAP/getApontamentoSAPByCentro/${centroTrabalho}`);
            setApontamentos(data);
            return data
        } catch (error) {
            console.error(error);
            setApontamentos([]);
        }

    }

    const ClearData = async () => {
        setDefectGroup(undefined);
        setDefect(undefined);
        setCause(undefined);
        setOrigin(undefined);
        setEquipment(undefined);
        setOrder("");
        setLossModal(false);
        setObservations("");
        setAppointmentType("");
        setDestiny("");
        setOrderFound(false);
    }

    const GetGroupDefectByOrigin = async (origem: string) => {
        try {
            const { data } = await blogFetch.get(
                `/CatalogoDefeitos/GroupDefect?origin=${origem}&sector=${centroTrabalhoSelect}`
            );
            setGroupDefects(data);
            return data
        } catch (error) {
            console.error(error);
        };
    };

    const GetDefectByGroupDefect = async (origem: string, grupoDefeito: string) => {
        try {
            const { data } = await blogFetch.get(
                `/CatalogoDefeitos/Defect?origin=${origem}&sector=${centroTrabalhoSelect}&grupoDefeito=${grupoDefeito}`
            );
            setDefects(data);
            return data
        } catch (error) {
            console.error(error);
        };
    };

    const GetCausesByDefect = async (origem: string, grupoDefeito: string, defeito: string) => {
        try {
            const { data } = await blogFetch.get(
                `/CatalogoDefeitos/Cause?defect=${defeito}&origin=${origem}&sector=${centroTrabalhoSelect}&grupoDefeito=${grupoDefeito}`
            );
            setCauses(data);
            return data
        } catch (error) {
            console.error(error);
        };
    };

    const SubmitAppointment = async () => {
        if (!dto || !origin || !cause || !appointmentType) {
            toast.error("Preencha todos os campos obrigatórios");
            return;
        }

        if (centroTrabalhoSelect == "06CURVAD" && equipment == undefined) {
            toast.error("Selecione o equipamento!");
            return;
        }

        if ((appointmentType == "RETRABALHO" || appointmentType == "REPROCESSO") && !destiny) {
            toast.error("Preencha o campo de destino!");
            return;
        }

        try {

            const formData = {
                Centro_Trabalho: centroTrabalhoSelect,
                Nro_Matricula: user.user_SAPMatricula,
                Ordem_Fabricacao: dto.Ordem_Serial,
                Operacao: "1000",
                Tipo_Apontamento: appointmentType,
                Defeito_Grupo: defectGroup,
                Defeito_Cod: defect,
                Origem_Grupo: origin.Origem_Cod,
                Origem_Cod: defect,
                Causa_Grupo: cause.Causa_Grupo,
                Causa_Cod: cause.Causa_Cod,
                Observacao: observations,
                Equipamento: equipment,
                Chave_Modelo: dto?.ADICIONAL_2,
                Integration_Status: "NA FILA",
                Destino: destiny,
                _ts_Creat: new Date(),
                _Creat: user.user_UserName ?? user.user_Matricula
            };
            if (photo) {
                const submitPhotoResponse = await SubmitPhoto();
                if (submitPhotoResponse == false) {
                    return;
                }
            }

            const response = await blogFetch.post('Loss/create', formData);

            if (response.data.success) {
                toast.success(response.data.message);
            } else {
                toast.error(response.data.message);
            }

            setLossModal(false);
            setSameDefectModal(true)
            setOrder("");
        } catch (error: any) {
            toast.error(error?.response?.data?.message ?? "Ocorreu um erro inesperado. Tente novamente.");
            return;
        }
    };

    const SubmitPhoto = async () => {
        if (!imageUrl) {
            toast.error("É preciso tirar a foto!");
            return;
        }
        try {

            const formData = new FormData();

            if (photo) {
                formData.append('entryFile', photo);
                formData.append('pathName', order);
            }
            else
                return;
            await blogFetch.post('Loss/create/photo', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            toast.success("Foto guardada com sucesso!");
            setPhotoModal(false);

        } catch (error) {
            console.error(error);
            toast.error("Erro ao salvar a foto");
            return false;
        }
        finally {
            setPhotoModal(false);
            setPhoto(undefined);
            setImageUrl("");
        }
    };

    const getOrder = async () => {
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }

        const controller = new AbortController();
        abortControllerRef.current = controller;

        try {
            const response = await blogFetch.get<DTO>(`Loss/get/${order}`, {
                signal: controller.signal,
            });
            setDTO(response.data);

            setOrderFound(true);

        } catch (error: any) {
            setOrderFound(false);
            if (axios.isAxiosError(error) && (error.code === "ERR_CANCELED" || error.name === "CanceledError")) {
                return;
            }
            if (axios.isAxiosError(error) && error.response?.status === 404) {
                toast.error("Ordem não encontrada!");
                return;
            }
            console.error("Outro erro:", error);
            toast.error("Erro ao buscar ordem.");
        }
    };

    const imprimirCodigoBarras = async () => {
        if (!ordem.trim()) {
            toast.error('Digite o número da ordem antes de imprimir.');
            return;
        }

        try {
            const response = await blogFetch.get<string>(`ISAGA_InspecaoFinal/getLotePorOrdem/${ordem}`);
            let lote = `I${response.data}`;

            JsBarcode(svgRef.current, lote, {
                format: 'CODE128',
                width: 3,
                height: 90,
                displayValue: false
            });

            if (!svgRef.current) return;

            const serializer = new XMLSerializer();
            const svgString = serializer.serializeToString(svgRef.current);

            const janela = window.open('', '_blank');
            if (janela) {
                janela.document.write(`
            <html>
                <head>
                <title>Etiqueta</title>
                <style>
                    @page { size: 10cm 3cm; margin: 0; }
                    body { display: flex; justify-content: center; align-items: center; margin: 0; }
                    svg { max-width: 100%; height: 100%; }
                </style>
                </head>
                <body>${svgString}<script>window.onload=()=>{window.print();window.close();}</script></body>
            </html>
        `);
                janela.document.close();
            }

            const novaInspecao = {
                inspecao_lote: lote,
                data_criado: new Date(),
                criadoPor: user.user_UserName,
                inpecao_status: 'Verificar',
            };

            await blogFetch.post('ISAGA_InspecaoFinal/CriarInspecaoFinal', novaInspecao);
            toast.success('Inspeção criada com sucesso!');
        } catch (error) {
            console.error(error);
            toast.error('Erro ao buscar o lote para esta ordem.');
        } finally {
            handleImpressaoCloseModal();
        }
    };

    const verificarCodigo = async () => {
        if (!loteVerificar.trim() || !loteVerificador.trim()) {
            toast.error('Preencha ambos os campos.');
            return;
        }

        if (loteVerificar.replace('I', '') !== loteVerificador) {
            toast.error('Os lotes não coincidem.');
            return;
        }

        try {
            await blogFetch.put(
                `ISAGA_InspecaoFinal/atualizarInspecao/${loteVerificar}`,
                user.user_UserName
            );
            toast.success('Lote verificado com sucesso!');
            handleModalCloseVerificador();
        } catch (error) {
            console.error(error);
            toast.error('Erro ao verificar o lote.');
        }
    };

    const handleApontamentoACV = async () => {
        if (!ciclo.trim() || !tipoApontamentoACV.trim()) {
            toast.error('Preencha todos os campos antes de salvar.');
            return;
        }

        try {
            await blogFetch.put('ApontamentoAutoClave/apontarCiclo', {
                ciclo,
                tipoApontamento: tipoApontamentoACV,
                user: user.user_UserName
            });

            toast.success('Apontamento realizado com sucesso!');
            setAtualizarListaACV(prev => prev + 1);
            handleCloseACVApontModal();
        } catch (error) {
            console.error(error);
            toast.error('Erro ao apontar ciclo.');
        }
    };

    function dataURLtoFile(dataurl: any, filename: string) {
        const arr = dataurl.split(",");
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[arr.length - 1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    }

    const capturePhoto = useCallback(async () => {
        try {
            const imageSrc = webcamRef.current?.getScreenshot();
            if (!imageSrc) {
                toast.error("Não foi possível capturar a foto");
                return;
            }
            setImageUrl(imageSrc);
            const orderText = `Ordem_${order}`;
            setPhoto(dataURLtoFile(imageSrc, orderText))

        } catch {
            toast.error("Câmera não carregada... Aguarde", {
                duration: 4000,
            });
        }
        finally {
            setPhotoModal(false);
        }

    }, [order, webcamRef]);
    //#endregion

    //#region Render
    return (
        <>
            <Navbar />
            <Sidebar />
            <div className="app_body p-0 d-flex flex-column">
                <div className="container-fluid flex-grow-1 d-flex flex-column">

                    <div className="my-4 d-flex justify-content-center align-items-center gap-3 flex-wrap">
                        <h1 className="h4 mb-0 text-gray-800">
                            Centro de Trabalho:
                        </h1>
                        <select
                            className="form-select form-select-sm w-auto shadow-sm rounded"
                            value={centroTrabalhoSelect}
                            onChange={(e) => setCentroTrabalhoSelect(e.target.value)}
                        >
                            <option value="">Escolha um Centro</option>
                            {CentroTrabalho.map((centro) => (
                                <option key={centro} value={centro}>
                                    {centro}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Menu */}
                    <div className="card mb-2">
                        <div className="card-header">
                            <h2 className="card-title h6 mb-0">Menu</h2>
                        </div>
                        <div className="card-body p-2 d-flex gap-2">

                            {/* {centroTrabalhoSelect === '18INSFIN' && (
                                <>

                                    <button
                                        className="btn btn-success btn-sm d-flex flex-column align-items-center text-center"
                                        onClick={() => setModalInspFinal(true)}>
                                        <Note fontSize="small" />
                                        Apontar_SAP
                                    </button>
                                </>

                            )} */}

                            {centroTrabalhoSelect === '15EMBOL' && (
                                <>
                                    <button
                                        className="btn btn-success btn-sm d-flex flex-column align-items-center text-center"
                                        onClick={() => setModalEmbolsado(true)}>
                                        <Note fontSize="small" />
                                        Apontar_SAP
                                    </button>
                                </>
                            )}

                            {centroTrabalhoSelect === '12P_MONT' && (
                                <>
                                    <button
                                        className="btn btn-success btn-sm d-flex flex-column align-items-center text-center"
                                        onClick={() => setModalPmont(true)}>
                                        <Note fontSize="small" />
                                        Apontar_SAP
                                    </button>
                                </>
                            )}

                            {centroTrabalhoSelect === '05EMPOLV' && (
                                <>
                                    <button
                                        className="btn btn-success btn-sm d-flex flex-column align-items-center text-center"
                                        onClick={() => setModalEmpolvado(true)}>
                                        <Note fontSize="small" />
                                        Apontar_SAP
                                    </button>
                                </>
                            )}

                            {centroTrabalhoSelect === '16ACV' && (
                                <>
                                    <button
                                        className="btn btn-success btn-sm d-flex flex-column align-items-center"
                                        onClick={() => setModalACV(true)}
                                    >
                                        <EditNote fontSize="small" />
                                        <span className="small">Criar Ciclo</span>
                                    </button>
                                </>

                            )}

                            {centroTrabalhoSelect === '03SERIG' && (
                                <>
                                    <button
                                        className="btn btn-success btn-sm d-flex flex-column align-items-center"
                                        onClick={() => setModalApontarSerigrafia(true)}
                                    >
                                        <Note fontSize="small" />
                                        <span className="small">Apontar</span>
                                    </button>
                                    <button
                                        className="btn btn-info btn-sm d-flex flex-column align-items-center"
                                        onClick={() => setModalQRSerigrafia(true)}
                                    >
                                        <CropFree fontSize="small" />
                                        <span className="small">Verificar QR</span>
                                    </button>
                                </>
                            )}

                            {centroTrabalhoSelect === '14MONTAG' && (
                                <>
                                    <button
                                        className="btn btn-success btn-sm d-flex flex-column align-items-center"
                                        onClick={() => window.location.href = "/listaMontagem"}
                                    >
                                        <ArrowCircleLeft fontSize="small" />
                                        <span className="small">Lista-Montagem</span>
                                    </button>
                                </>

                            )}

                            {centroTrabalhoSelect && !CentroTrabalhoSemApontamentoPerda.includes(centroTrabalhoSelect) && (
                                <button
                                    className='btn btn-danger btn-sm d-flex flex-column align-items-center rounded-3 shadow-sm'
                                    onClick={() => setLossModal(true)}
                                >
                                    <FindReplace fontSize="small" />
                                    <span className="small">Perdas</span>
                                </button>
                            )}
                        </div>
                    </div>
                    {/* Tabelas dinâmicas */}
                    {centroTrabalhoSelect === '14MONTAG' && (
                        <div className="d-flex flex-column overflow-y-auto">

                            <TabelaResumoOrdens
                                ordemInicial={ordemSelecionada}
                                onApontamentoCompleted={() => GetAppointmentsBySector('14MONTAG')}
                            />


                        </div>
                    )}

                    {centroTrabalhoSelect === '16ACV' && (
                        <div className="d-flex flex-column overflow-y-auto">
                            <TabelaApontametosACV atualizarSignal={atualizarListaACV} />
                        </div>
                    )}

                </div>


                {apontamentos.length > 0 && (
                    <div className="card mt-3" style={{ marginBottom: "20px" }}>
                        <div className="card-header bg-light">
                            <h5 className="card-title mb-0 h6">Apontamentos - {centroTrabalhoSelect} ({apontamentos.length})</h5>
                        </div>
                        <div className="card-body p-0">
                            <div style={{
                                maxHeight: "200px",
                                overflowY: "auto",
                                overflowX: "hidden",
                                borderTop: "1px solid #dee2e6"
                            }}>
                                <table className="table table-sm table-striped table-hover mb-0">
                                    <thead className="table-light" style={{ position: "sticky", top: 0, zIndex: 10 }}>
                                        <tr>
                                            <th className="text-center" style={{ width: "8%", padding: "0.5rem" }}>Data</th>
                                            <th className="text-center" style={{ width: "8%", padding: "0.5rem" }}>Centro</th>
                                            <th className="text-center" style={{ width: "8%", padding: "0.5rem" }}>Ordem</th>
                                            <th className="text-center" style={{ width: "8%", padding: "0.5rem" }}>Operação</th>
                                            <th className="text-center" style={{ width: "8%", padding: "0.5rem" }}>Tipo</th>
                                            <th className="text-center" style={{ width: "8%", padding: "0.5rem" }}>Usuário</th>
                                            <th className="text-center" style={{ width: "8%", padding: "0.5rem" }}>Status</th>
                                            <th className="text-center" style={{ width: "8%", padding: "0.5rem" }}>Defeito Grupo</th>
                                            <th className="text-center" style={{ width: "8%", padding: "0.5rem" }}>Defeito Cod</th>
                                            <th className="text-center" style={{ width: "8%", padding: "0.5rem" }}>Origem Grupo</th>
                                            <th className="text-center" style={{ width: "8%", padding: "0.5rem" }}>Origem Cod</th>
                                            <th className="text-center" style={{ width: "8%", padding: "0.5rem" }}>Causa Grupo</th>
                                            <th className="text-center" style={{ width: "8%", padding: "0.5rem" }}>Causa Cod</th>
                                            <th className="text-center" style={{ width: "8%", padding: "0.5rem" }}>Equipamento</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {apontamentos.map((apt: Apontamento, index: number) => (
                                            <tr key={`${centroTrabalhoSelect}-${index}`}>
                                                <td className="text-center small" style={{ padding: "0.5rem" }}>
                                                    {apt._ts_Creat ? new Date(apt._ts_Creat).toLocaleString("pt-BR") : "—"}
                                                </td>
                                                <td className="text-center small" style={{ padding: "0.5rem" }}>{apt.centro_Trabalho}</td>
                                                <td className="text-center small" style={{ padding: "0.5rem" }}>{apt.ordem_Fabricacao}</td>
                                                <td className="text-center small" style={{ padding: "0.5rem" }}>{apt.operacao}</td>
                                                <td className="text-center small" style={{ padding: "0.5rem" }}>{apt.tipo_Apontamento}</td>
                                                <td className="text-center small" style={{ padding: "0.5rem" }}>{apt.nro_Matricula}</td>
                                                <td className={`text-center small ${apt.integration_Status == "NA FILA" ? 'bg-warning' : apt.integration_Status == "ERROR" ? 'bg-danger' : 'bg-success'}`} style={{ padding: "0.5rem" }}>{apt.integration_Status}</td>
                                                <td className="text-center small" style={{ padding: "0.5rem" }}>{apt.defeito_Grupo}</td>
                                                <td className="text-center small" style={{ padding: "0.5rem" }}>{apt.defeito_Cod}</td>
                                                <td className="text-center small" style={{ padding: "0.5rem" }}>{apt.origem_Grupo}</td>
                                                <td className="text-center small" style={{ padding: "0.5rem" }}>{apt.origem_Cod}</td>
                                                <td className="text-center small" style={{ padding: "0.5rem" }}>{apt.causa_Grupo}</td>
                                                <td className="text-center small" style={{ padding: "0.5rem" }}>{apt.causa_Cod}</td>
                                                <td className="text-center small" style={{ padding: "0.5rem" }}>{apt.equipamento}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                )}



                {/* ---------- MODAIS ---------- */}

                {/* modal de foto */}
                <Modal backdrop="static" keyboard={false} centered show={photoModal} onHide={(() => { setPhotoModal(false) })} size="xl">
                    <Modal.Header closeButton>
                        <Modal.Title>Tirar foto</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="d-flex justify-content-center align-items-center" style={{ minHeight: "400px" }}>
                        <div style={{ width: "100%", maxWidth: "500px" }}>
                            {imageUrl === "" ? (
                                <div className="d-flex justify-content-center">
                                    <Webcam
                                        ref={webcamRef}
                                        audio={false}
                                        screenshotFormat="image/jpeg"
                                        videoConstraints={videoConstraints}
                                        style={{
                                            width: "100%",
                                            maxWidth: "500px",
                                            height: "auto",
                                            borderRadius: "8px",
                                            aspectRatio: "4/3"
                                        }}
                                        mirrored={false}
                                    />
                                </div>
                            ) : (
                                <div className="d-flex justify-content-center">
                                    <img
                                        src={imageUrl}
                                        alt="captured"
                                        style={{
                                            width: "100%",
                                            maxWidth: "500px",
                                            height: "auto",
                                            borderRadius: "8px",
                                            aspectRatio: "4/3",
                                            objectFit: "cover"
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-secondary" onClick={(() => {
                            setImageUrl("");
                        })}>Limpar</button>
                        <button className="btn btn-secondary" onClick={(() => {
                            setPhotoModal(false);
                        })}>Fechar</button>
                        <button className="btn btn-success" onClick={(() => {
                            // SubmitAppointment();
                            capturePhoto();
                        })}>Tirar foto</button>
                    </Modal.Footer>
                </Modal>

                {/* modal de refugo */}
                <Modal backdrop="static" keyboard={false} centered show={lossModal} onHide={(() => { ClearData() })} size="xl">
                    <Modal.Header closeButton>
                        <Modal.Title>Apontar peça</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <label className="form-label fw-bold">Insira a ordem da peça:</label>
                        <input
                            type="text"
                            className="form-control form-control-sm mb-3"
                            value={order}
                            onChange={(x) => setOrder(x.target.value)}
                        />
                        {orderFound && (
                            <>
                                <div className="btn-group" role="group" aria-label="Tipo de apontamento">

                                    {CentroTrabalhoReprocesso.includes(centroTrabalhoSelect) &&
                                        (<>
                                            <input
                                                type="radio"
                                                className="btn-check"
                                                name="appointmentType"
                                                id="appt2"
                                                autoComplete="off"
                                                value="REPROCESSO"
                                                checked={appointmentType === "REPROCESSO"}
                                                onChange={(e) => setAppointmentType(e.target.value)}
                                            />
                                            <label
                                                className="btn btn-warning text-dark fw-semibold"
                                                htmlFor="appt2"
                                                style={{ opacity: appointmentType === "REPROCESSO" ? 1 : 0.55 }}
                                            >Reprocesso</label>
                                        </>)}

                                    {/* {CentroTrabalhoRetrabalho.includes(centroTrabalhoSelect) &&
                                        (<>
                                            <input
                                                type="radio"
                                                className="btn-check"
                                                name="appointmentType"
                                                id="appt3"
                                                autoComplete="off"
                                                value="RETRABALHO"
                                                checked={appointmentType === "RETRABALHO"}
                                                onChange={(e) => setAppointmentType(e.target.value)}
                                            />
                                            <label className="btn btn-outline-secondary" htmlFor="appt3">Retrabalho</label>
                                        </>)} */}

                                    {CentroTrabalhoRefugo.includes(centroTrabalhoSelect) &&
                                        (<>
                                            <input
                                                type="radio"
                                                className="btn-check"
                                                name="appointmentType"
                                                id="appt1"
                                                autoComplete="off"
                                                value="REFUGO"
                                                checked={appointmentType === "REFUGO"}
                                                onChange={(e) => setAppointmentType(e.target.value)}
                                            />
                                            <label
                                                className="btn btn-danger text-dark fw-semibold"
                                                htmlFor="appt1"
                                                style={{ opacity: appointmentType === "REFUGO" ? 1 : 0.55 }}
                                            >Refugo</label>
                                        </>)}

                                </div>

                                {dto?.Ordem_SetAtual != centroTrabalhoSelect && (
                                    <>
                                        <div className='mt-2'>
                                            <p className='text-danger'>A ordem digitada não está no mesmo centro de trabalho que o selecionado!</p>
                                        </div>
                                    </>)}

                                <div >

                                </div>

                                {dto?.inGSA == false && (
                                    <>
                                        <div className='mt-2'>
                                            <p className='text-danger'>A ordem não está registrada no GSA!</p>
                                        </div>
                                    </>)}

                                <div >
                                    {appointmentType &&
                                        (<>

                                            {appointmentType === "REFUGO" &&
                                                (<>
                                                    <div className="mb-3">
                                                        <label className="form-label fw-bold">Adicionar Foto</label>
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-secondary w-100 d-flex align-items-center justify-content-center gap-2"
                                                            onClick={() => {
                                                                setPhotoModal(true);
                                                            }}
                                                        >
                                                            <AddAPhoto />
                                                            <span>Tirar Foto</span>
                                                        </button>

                                                        {imageUrl && (
                                                            <div className="d-flex justify-content-center mt-2">
                                                                <img
                                                                    src={imageUrl}
                                                                    alt="captured"
                                                                    style={{
                                                                        width: "100%",
                                                                        maxWidth: "300px",
                                                                        height: "auto",
                                                                        borderRadius: "8px",
                                                                        aspectRatio: "4/3",
                                                                        objectFit: "cover"
                                                                    }}
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                </>
                                                )
                                            }

                                            <label className="form-label fw-bold">Ordem</label>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm mb-3"
                                                value={dto?.Ordem_Serial}
                                                disabled
                                            />

                                            <label className="form-label fw-bold">Chave modelo</label>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm mb-3"
                                                value={dto?.ADICIONAL_2}
                                                disabled
                                            />

                                            <label className="form-label fw-bold">Origem:</label>
                                            <select
                                                value={origin?.Origem_Cod || ''}
                                                onChange={(e) => {
                                                    const selected = origins.find(apt => apt.cod_Origem === e.target.value)
                                                    if (selected) {
                                                        setOrigin({
                                                            Origem_Cod: selected.cod_Origem,
                                                            Origem_Grupo: selected.cod_Grupo_Defeitos,
                                                        })
                                                    } else {
                                                        setOrigin(undefined)
                                                    }
                                                }}
                                                className="form-select form-control form-control-sm mb-3"
                                            >
                                                <option value="">Selecione...</option>
                                                {origins.map((option, index) => (
                                                    <option key={index} value={option.cod_Origem}>
                                                        {`${option.cod_Origem} (${option.origem_Setor})`}
                                                    </option>
                                                ))}
                                            </select>

                                            <label className="form-label fw-bold">Grupo defeito:</label>
                                            <select
                                                value={defectGroup || ''}
                                                disabled={origin ? false : true}
                                                onChange={(e) => setDefectGroup(e.target.value)}
                                                className="form-select form-control form-control-sm mb-3"
                                            >
                                                <option value="">Selecione...</option>
                                                {groupDefects.map((option, index) => (
                                                    <option key={index} value={option.cod_Grupo_Defeitos}>
                                                        {`${option.cod_Grupo_Defeitos} (${option.grupo_Defeito})`}
                                                    </option>
                                                ))}
                                            </select>

                                            <label className="form-label fw-bold">Defeito:</label>
                                            <select
                                                value={defect || ''}
                                                disabled={origin && defectGroup ? false : true}
                                                onChange={(e) => setDefect(e.target.value)}
                                                className="form-select form-control form-control-sm mb-3"
                                            >
                                                <option value="">Selecione...</option>
                                                {defects.map((option, index) => (
                                                    <option key={index} value={option.cod_Defeito}>
                                                        {`${option.cod_Defeito} (${option.defeito})`}
                                                    </option>
                                                ))}
                                            </select>

                                            <label className="form-label fw-bold">Causa:</label>
                                            <select
                                                value={cause?.Causa_Cod || ''}
                                                disabled={origin && defectGroup && defect ? false : true}

                                                onChange={(e) => {
                                                    const selected = causes.find(c => c.cod_Causa === e.target.value)
                                                    if (selected) {
                                                        setCause({
                                                            Causa_Cod: selected.cod_Causa,
                                                            Causa_Grupo: selected.cod_Origem,
                                                        })
                                                    } else {
                                                        setCause(undefined)
                                                    }
                                                }}
                                                className="form-select form-control form-control-sm mb-3"
                                            >
                                                <option value="">Selecione...</option>
                                                {causes.map((option, index) => (
                                                    <option key={index} value={option.cod_Causa}>
                                                        {`${option.causa} (${option.cod_Causa})`}
                                                    </option>
                                                ))}
                                            </select>

                                            {centroTrabalhoSelect == "06CURVAD" &&
                                                (
                                                    <>
                                                        <label className="form-label fw-bold">Equipamento:</label>
                                                        <select
                                                            value={equipment || ''}
                                                            // disabled={origin && defectGroup ? false : true}
                                                            onChange={(e) => setEquipment(e.target.value)}
                                                            className="form-select form-control form-control-sm mb-3"
                                                        >
                                                            <option value="">Selecione...</option>
                                                            <option value="21-HCV01">FORNO CRISMACH (21-HCV01)</option>
                                                            <option value="21-HCV02">FORNO H GLASSROBOT (21-HCV02)</option>
                                                            <option value="21-HCV03">FORNO HBT (21-HCV03)</option>
                                                            <option value="21-HCV05">FORNO TAM GLASS (21-HCV05)</option>
                                                            <option value="21-HCV06">FORNO SGLASS (21-HCV06)</option>
                                                            <option value="21-HCV07">FORNO G SGLASS (21-HCV07)</option>
                                                        </select>
                                                    </>
                                                )}


                                            {(appointmentType == "RETRABALHO" || appointmentType == "REPROCESSO") && (
                                                <>
                                                    <label className="form-label fw-bold">Destino:</label>
                                                    <select
                                                        value={destiny}
                                                        onChange={(e) => setDestiny(e.target.value)}
                                                        className="form-select form-control form-control-sm mb-3"
                                                    >
                                                        <option value="">Selecione o destino...</option>
                                                        {Destinos.map((d) => (
                                                            <option key={d} value={d}>{d}</option>
                                                        ))}
                                                    </select>
                                                </>)}

                                            <label className="form-label fw-bold">Comentarios</label>
                                            <textarea
                                                value={observations}
                                                onChange={(e) => setObservations(e.target.value)}
                                                className="form-control"
                                                placeholder="Leave a comment here"
                                                maxLength={40}
                                            />
                                            <small className="text-muted">{(observations?.length ?? 0)}/40</small>
                                        </>)}
                                </div>

                            </>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-secondary" onClick={(() => {
                            setOrder("");
                            setAppointmentType("");
                            ClearData();
                            if (gsaOrder && gsaSector) {
                                navigate('/dashboard', {
                                    state: {
                                        isGsa: true,
                                    }
                                });
                            }

                        })}>Fechar</button>
                        <button disabled={!enableAppontmentSubmit} className="btn btn-success" onClick={(() => {
                            setConfirmSubmitModal(true);
                        })}>Enviar</button>
                    </Modal.Footer>
                </Modal>

                {/* Modal de confirmação do tipo de apontamento */}
                <Modal backdrop="static" keyboard={false} centered show={confirmSubmitModal} onHide={() => setConfirmSubmitModal(false)}>
                    {(() => {
                        const isRefugo = appointmentType === "REFUGO";
                        const variant = isRefugo ? "danger" : "warning";
                        const label = isRefugo ? "REFUGO" : "REPROCESSO";
                        return (
                            <>
                                <Modal.Header closeButton className={`bg-${variant} text-dark`}>
                                    <Modal.Title>Confirmar apontamento</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <div className={`alert alert-${variant} mb-0 fs-5 fw-semibold text-center`}>
                                        Tem certeza que deseja apontar esta peça como <strong>{label}</strong>?
                                    </div>
                                </Modal.Body>
                                <Modal.Footer>
                                    <button className="btn btn-secondary" onClick={() => setConfirmSubmitModal(false)}>Cancelar</button>
                                    <button className={`btn btn-${variant}`} onClick={() => {
                                        setConfirmSubmitModal(false);
                                        SubmitAppointment();
                                    }}>Confirmar {label}</button>
                                </Modal.Footer>
                            </>
                        );
                    })()}
                </Modal>

                <Modal backdrop="static" keyboard={false} centered show={sameDefectModal} onHide={(() => { ClearData() })} size="xl">
                    <Modal.Header closeButton>
                        <Modal.Title>Deseja apontar com os mesmos defeitos?</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <label className="form-label fw-bold">Nova ordem</label>
                        <input
                            type="text"
                            className="form-control form-control-sm mb-3"
                            value={order}
                            onChange={(x) => setOrder(x.target.value)}
                        />
                        <button className="btn btn-secondary pr-4" onClick={(() => {
                            setSameDefectModal(false)
                            setOrder("");
                            setAppointmentType("");
                            ClearData();
                            if (gsaOrder && gsaSector) {
                                navigate('/dashboard', {
                                    state: {
                                        isGsa: true,
                                    }
                                });
                            }
                        })}>Não</button>
                        <button className="btn btn-success ms-2" onClick={(() => {
                            // SubmitAppointment();
                            setSameDefectModal(false);
                            setLossModal(true);
                        })}
                            disabled={order == ""}
                        >Sim</button>
                    </Modal.Body>
                </Modal>


                {/* Modal Impressão */}
                <Modal centered show={modalImpressao} onHide={handleImpressaoCloseModal} size="lg">
                    <Modal.Header closeButton><Modal.Title>Imprimir código</Modal.Title></Modal.Header>
                    <Modal.Body>
                        <input
                            type="text"
                            className="form-control form-control-sm mb-3"
                            placeholder="Digite o número da ordem"
                            value={ordem}
                            onChange={(e) => setOrdem(e.target.value)}
                        />
                        <svg ref={svgRef} style={{ display: 'none' }}></svg>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-secondary" onClick={handleImpressaoCloseModal}>Fechar</button>
                        <a className="btn btn-success" href={`sagaprintserver:BR-BufferFornos;SAGA_User;${ordem}`}>Imprimir</a>
                        {/* <button className="btn btn-success" onClick={imprimirCodigoBarras}>Imprimir</button> */}
                    </Modal.Footer>
                </Modal>

                {/* Modal Verificador */}
                <Modal centered show={modalVerificador} onHide={handleModalCloseVerificador}>
                    <Modal.Header closeButton><Modal.Title>Verificar Peça</Modal.Title></Modal.Header>
                    <Modal.Body>
                        <Form.Group className="mb-3">
                            <Form.Label>Código de barras:</Form.Label>
                            <Form.Control
                                type="text"
                                value={loteVerificar}
                                onChange={(e) => setLoteVerificar(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Confirmar código:</Form.Label>
                            <Form.Control
                                type="text"
                                value={loteVerificador}
                                onChange={(e) => setLoteVerificador(e.target.value)}
                            />
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-secondary" onClick={handleModalCloseVerificador}>Fechar</button>
                        <button className="btn btn-success" onClick={verificarCodigo}>Enviar</button>
                    </Modal.Footer>
                </Modal>

                {/* Modal Criação Ciclo */}
                <Modal centered show={modalACV} onHide={handleACVCloseModal} size="xl">
                    <Modal.Header closeButton><Modal.Title>Criação de Ciclo</Modal.Title></Modal.Header>
                    <Modal.Body>
                        <ModalApontamentoACV
                            onCancel={handleACVCloseModal}
                            onSubmit={async (dados) => {
                                try {
                                    await blogFetch.post('ApontamentoAutoClave/criarCiclo', dados);
                                    toast.success('Ciclo criado com sucesso!');
                                    setAtualizarListaACV(prev => prev + 1);
                                    handleACVCloseModal();
                                } catch (error) {
                                    toast.error('Erro ao criar ciclo.');
                                }
                            }}
                        />
                    </Modal.Body>
                </Modal>

                {/* Modal Apontamento ACV */}
                <Modal centered show={modalApontACVModal} onHide={handleCloseACVApontModal}>
                    <Modal.Header closeButton><Modal.Title>Apontar Ciclo</Modal.Title></Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Form.Group className="mb-3">
                                <Form.Label>Número do Ciclo</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={ciclo}
                                    onChange={(e) => setCiclo(e.target.value)}
                                />
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>Tipo de Apontamento</Form.Label>
                                <Form.Select
                                    value={tipoApontamentoACV}
                                    onChange={(e) => setTipoApontamentoACV(e.target.value)}
                                >
                                    <option value="">Escolha o tipo</option>
                                    <option value="Entrada">Entrada</option>
                                    <option value="Saida">Saída</option>
                                </Form.Select>
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-secondary" onClick={handleCloseACVApontModal}>Fechar</button>
                        <button className="btn btn-success" onClick={handleApontamentoACV}>Salvar</button>
                    </Modal.Footer>
                </Modal>

                <ModalApontamentoEmbolsado
                    show={modalEmbolsado}
                    onHide={() => setModalEmbolsado(false)}
                />
                <ModalApontamentoPmont
                    show={modalPmont}
                    onHide={() => setModalPmont(false)}
                />
                <ModalApontamentoEmpolvado
                    show={modalEmpolvado}
                    onHide={() => setModalEmpolvado(false)}
                />
                <ModalApontamentoSerigrafia
                    show={modalApontarSerigrafia}
                    onHide={() => setModalApontarSerigrafia(false)}
                />
                <ModalQRSerigrafia
                    show={modalQRSerigrafia}
                    onHide={() => setModalQRSerigrafia(false)}
                />
                <ModalApontamentoInspFinal
                    show={modalInspFinal}
                    onHide={() => setModalInspFinal(false)}
                />
            </div>
        </>
    );
};
